import { CommonTooltips } from "@mcleod/common";
import { AutogenLayoutBulkUpdatesConfirmation } from "./autogen/AutogenLayoutBulkUpdatesConfirmation";
import { DropdownSelectionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { Model, ModelRow } from "@mcleod/core";

export class BulkUpdatesConfirmation extends AutogenLayoutBulkUpdatesConfirmation {
    private payrollControl: ModelRow;

    async onLoad(): Promise<void> {
        this.payrollControl = await Model.searchSingleRecord("lme/dispatch/payroll-control", null, ["deduct_tied_order"]);
        if (this.payrollControl.getBoolean("deduct_tied_order")) {
            this.checkboxAssociatePayAdjustments.checked = true;
            this.checkboxAssociatePayAdjustments.enabled = false;
        }
    }

    /** This is an event handler for the afterDropdownSelection event of textboxStatus. */
    textboxStatusAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.textboxReasonCode.enabled = this.textboxStatus.valueAsString == "N";
        this.textboxComment.enabled = this.textboxStatus.valueAsString == "N"
        if (this.textboxStatus.valueAsString != "N") {
            this.textboxReasonCode.clear();
            this.textboxComment.clear();
        }
    }

    textboxReasonCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y";
        event.filter.code_type = "S";
    }

    /** This is an event handler for the onLookupModelSelection event of textboxReasonCode. */
    textboxReasonCodeOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()){
            CommonTooltips.setTooltipContentLayout(
                this.textboxReasonCode,
                event.selection?.get("id"),
                "lme/settlement/BackOfficeReasonCodeQuickInfo"
            );
        }
    }
}
